module.exports = __webpack_public_path__ + "resources/img/img_ahnlab_cpp2_en.d022af6339c4e0d7d16ce01226a47e3d.png";